import React from "react";
import { connect } from "react-redux";
import {
    issueDiscovery,
    problemConfirmation,
    solutionDelivery,
    followupMentions,
} from "./data";
import TicketDetailHeading from "./TicketDetailHeading/TicketDetailHeading";
import CustomScroll from "components/ui/CustomScroll/CustomScroll";
import { ticketPhases } from "components/dashboard/AgentInbox/enum";
import "./TicketDetailHeader.scss";
import { FOLLOW_UP_LATEST_ACTIVITY } from "./TicketDetailHeading/enum";
import { useSelector } from "react-redux";
import { roleHasPermission } from "utils/permissions/rolePermissions";

const { ISSUE_DISCOVERY, PROBLEM_CONFIRMATION, SOLUTION_DELIVERY } =
    ticketPhases;

const TicketDetailHeader = ({
    selectedTicketHeader,
    selectedTicketPhase,
    handleSelectedTicketHeader,
    selectedTicket,
    role,
}) => {
    const effectivePhase =
        selectedTicketPhase === ticketPhases.ALL
            ? selectedTicket?.ticketPhase || selectedTicketPhase
            : selectedTicketPhase;

    const ticketsDetailHeaderData =
        effectivePhase === ISSUE_DISCOVERY
            ? issueDiscovery
            : effectivePhase === PROBLEM_CONFIRMATION
            ? problemConfirmation
            : effectivePhase === SOLUTION_DELIVERY
            ? solutionDelivery
            : followupMentions;

    const visibleTabs = ticketsDetailHeaderData.filter((tab) =>
        roleHasPermission(role, tab.baseResources)
    );

    const { followUpLatestActivity } = selectedTicket || {};
    const { type: activityType } = followUpLatestActivity || {};

    const {
        lastestActivity
    } = useSelector((state) => state.tickets) || {};
    const { ticketId, ticketActivity } = lastestActivity || {}

    return (
        <div key={effectivePhase}>
            <CustomScroll
                selector='ticket__details__header'
                parentScrollId={"ticket__details__header"}
                activeElement={selectedTicketHeader}
                axis='x'
                className='tickets__detail--header'>
                {visibleTabs?.map(({ value, label }, index) => {
                    return (
                        <TicketDetailHeading
                            key={index}
                            label={label}
                            value={value}
                            isActive={value === selectedTicketHeader}
                            onClick={() => handleSelectedTicketHeader(value)}
                            hasNew={
                                (value ===
                                    FOLLOW_UP_LATEST_ACTIVITY[activityType] &&
                                    value !== FOLLOW_UP_LATEST_ACTIVITY.TASK) ||
                                (value === ticketActivity &&
                                    ticketId === selectedTicket?.ticketId)
                            }
                        />
                    );
                })}
            </CustomScroll>
        </div>
    );
};

export default connect((state) => ({
    role: state?.auth?.user?.role,
}))(TicketDetailHeader);
